import { styled } from "../../../../../../styles";

export const Container = styled("div", {
  display: "flex",
  flexDirection: "column",
  height: "auto",
  width: "743px",
  gap: "12px",

  "@sm": {
    width: "100%",
  },
});

export const Title = styled("h1", {
  fontWeight: 500,
  fontSize: "$text-xl",
  lineHeight: "22px",
  padding: "24px 22px 32px 22px",
  color: "$black",
});

export const SubmitContainer = styled("div", {
  display: "flex",
  gap: "40px",
  padding: "24px 22px 24px 22px",
  alignItems: "center",
});

export const CancelButton = styled("button", {
  height: "$13",
  padding: "0 $13",
  marginLeft: "-38px",

  borderRadius: "20px",
  border: "2px solid $white",

  backgroundColor: "$white",

  gap: "$4",

  display: "flex",
  alignItems: "center",

  color: "$black",
  fontWeight: 600,
  lineHeight: "22px",
  fontSize: "$text-lg",
  fontFamily: "$openSans",

  cursor: "pointer",

  "&:focus": {
    outline: "none",
    border: "2px solid $primary-30",
  },

  "@sm": {
    width: "80px",
    height: "26px",
    fontSize: "12px",
    marginLeft: "40px",
    paddingLeft: "19px",
  },
});

export const Label = styled("p", {
  paddingLeft: 22,
  color: "$gray-100",
  lineHeight: "22px",
  fontSize: "14px",
  fontWeight: "400",
});

export const LabelWeight = styled("p", {
  paddingLeft: 22,
  color: "$gray-100",
  lineHeight: "22px",
  fontSize: "14px",
  fontWeight: "500",
});

export const DetailsContainer = styled("div", {
  display: "flex",
  flexDirection: "row",
  paddingLeft: "0px",

  "@sm": {
    flexDirection: "column",
  },
});

export const NoteContainer = styled("div", {
  padding: "28px",

  "@sm": {
    paddingLeft: "0px",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
});

export const ChildOneContainer = styled("div", {
  width: "100%",
  padding: "28px",

  "@sm": {
    paddingLeft: "0px",
    paddingTop: "20px",
    paddingBottom: "20px",
  },
});

export const BackgroundContainer = styled("div", {
  backgroundColor: "#FAFAFA",
  borderRadius: "8px",
  margin: "28px",
});
